import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [view, setView] = useState('journal');
  const [day, setDay] = useState(1);
  const [reflection, setReflection] = useState('');
  const [gratitude, setGratitude] = useState('');
  const [mood, setMood] = useState('peaceful');
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [entries, setEntries] = useState([]);

  const icons = [
    { id: 1, src: '/icons/icon1.png', name: 'Prayer Mat' },
    { id: 2, src: '/icons/icon2.png', name: 'Moon' },
    { id: 3, src: '/icons/icon3.png', name: 'Dates' },
    { id: 4, src: '/icons/icon4.png', name: 'Soup' },
    { id: 5, src: '/icons/icon5.png', name: 'Mosque' },
    { id: 6, src: '/icons/icon6.png', name: 'Quran' }
  ];

  useEffect(() => {
    if (view === 'calendar') {
      fetchEntries();
    }
  }, [view]);

  const fetchEntries = async () => {
  try {
    const response = await fetch('https://ramadan-reflections.onrender.com/api/entries');
      const data = await response.json();
      setEntries(data);
    } catch (error) {
      console.error('Error fetching entries:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowIconPicker(true);
  };

  const handleDayClick = async (dayNum) => {
    const existingEntry = entries.find(e => e.day === dayNum);
    
    if (existingEntry) {
      setDay(dayNum);
      setReflection(existingEntry.reflection);
      setGratitude(existingEntry.gratitude || '');
      setMood(existingEntry.mood);
      setView('journal');
    } else {
      setDay(dayNum);
      setReflection('');
      setGratitude('');
      setMood('peaceful');
      setView('journal');
    }
  };

  const handleIconSelect = async (icon) => {
    console.log('Attempting to save with icon:', icon);
    
    try {
      const payload = {
        day,
        reflection,
        gratitude,
        mood,
        imageUrl: icon
      };
      
      console.log('Sending payload:', payload);
      
      const response = await fetch('https://ramadan-reflections.onrender.com/api/entries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Server error:', errorData);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Entry saved successfully:', data);
      
      setReflection('');
      setGratitude('');
      setShowIconPicker(false);
      setDay(day + 1);
      
      fetchEntries();
    } catch (error) {
      console.error('Error saving entry:', error);
      alert('Error saving entry: ' + error.message);
    }
  };

  if (view === 'calendar') {
    return (
      <div className="App">
        <div className="calendar-container">
          <div className="calendar-header">
            <button onClick={() => setView('journal')} className="back-btn">← Back</button>
            <h1>🌙 My Ramadan Journey</h1>
          </div>
          
          <div className="calendar-grid">
            {[...Array(30)].map((_, index) => {
              const dayNum = index + 1;
              const dayEntries = entries.filter(e => e.day === dayNum && e.imageUrl);
              const entry = dayEntries.length > 0 ? dayEntries[dayEntries.length - 1] : null;
              
              return (
                <div 
                  key={dayNum} 
                  className="calendar-day" 
                  onClick={() => handleDayClick(dayNum)}
                  style={{cursor: 'pointer'}}
                >
                  <div className="day-number">Day {dayNum}</div>
                  <div className="day-icon">
                    {entry && entry.imageUrl ? (
                      <img src={entry.imageUrl} alt="icon" className="calendar-icon-image" />
                    ) : (
                      '·'
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="container">
        <div className="phone-header">
          <h1>Journal</h1>
          <p>Write one memory a day</p>
          <p>to grow your garden</p>
          <div className="doodles">🌙 ⭐ 🕌 🌸</div>
          <div className="day-badge">Day {day} of 30</div>
          <button onClick={() => setView('calendar')} className="view-calendar-btn">
            View Calendar 📅
          </button>
        </div>

        {!showIconPicker ? (
          <form onSubmit={handleSubmit} className="journal-form">
            <div className="form-group">
              <label>today</label>
              <textarea
                value={reflection}
                onChange={(e) => setReflection(e.target.value)}
                placeholder="Today I..."
                className="textarea"
                rows="6"
                required
              />
            </div>

            <div className="form-group">
              <label>grateful for</label>
              <textarea
                value={gratitude}
                onChange={(e) => setGratitude(e.target.value)}
                placeholder="Alhamdulillah for..."
                className="textarea"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label>feeling</label>
              <select
                value={mood}
                onChange={(e) => setMood(e.target.value)}
                className="select"
              >
                <option value="peaceful">peaceful 😌</option>
                <option value="grateful">grateful 🙏</option>
                <option value="joyful">joyful 😊</option>
                <option value="reflective">reflective 🤔</option>
                <option value="hopeful">hopeful ✨</option>
              </select>
            </div>

            <button type="submit" className="submit-btn">
              Done
            </button>
          </form>
        ) : (
          <div className="icon-picker">
            <h2>Pick your symbol for today 🌙</h2>
            <p>Choose what represents Day {day}</p>
            <div className="icon-grid">
              {icons.map((icon) => (
                <button
                  key={icon.id}
                  onClick={() => handleIconSelect(icon.src)}
                  className="icon-btn"
                >
                  <img src={icon.src} alt={icon.name} className="icon-image" />
                </button>
              ))}
            </div>
            <button onClick={() => setShowIconPicker(false)} className="cancel-btn">
              ← Back
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;